document.addEventListener('change', event => {
  if (!event.target.matches('[data-variant-select]')) return;
  const option = event.target.selectedOptions[0];
  const details = event.target.closest('.product-details');
  details.querySelector('[data-product-price]').textContent = option.dataset.price;
  const button = details.querySelector('[data-add-button]');
  button.disabled = option.dataset.available !== 'true';
  button.textContent = button.disabled ? 'Sold out' : 'Add to bag';
});

const driftMenu = document.querySelector('.mobile-menu');
const driftMenuToggle = document.querySelector('[data-menu-open]');
if (driftMenu && driftMenuToggle) {
  driftMenuToggle.addEventListener('click', () => {
    driftMenu.showModal();
    driftMenuToggle.setAttribute('aria-expanded', 'true');
  });
  driftMenu.querySelector('[data-menu-close]').addEventListener('click', () => driftMenu.close());
  driftMenu.addEventListener('close', () => driftMenuToggle.setAttribute('aria-expanded', 'false'));
  driftMenu.addEventListener('click', event => {
    if (event.target !== driftMenu) return;
    const bounds = driftMenu.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) driftMenu.close();
  });
  matchMedia('(min-width: 900px)').addEventListener('change', event => {
    if (event.matches && driftMenu.open) driftMenu.close();
  });
}
